/**
 * Age from calendar birth date (YYYY-MM-DD), local calendar rules (no UTC drift).
 */
export function calculateAgeFromBirthdate(birthdate) {
  if (birthdate == null || birthdate === '') return null;
  const datePart = String(birthdate).trim().split('T')[0];
  const parts = datePart.split('-');
  if (parts.length !== 3) return null;
  const y = parseInt(parts[0], 10);
  const m = parseInt(parts[1], 10);
  const d = parseInt(parts[2], 10);
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return null;

  const today = new Date();
  const ty = today.getFullYear();
  const tm = today.getMonth() + 1;
  const td = today.getDate();
  let age = ty - y;
  if (tm < m || (tm === m && td < d)) age -= 1;
  return age;
}

/** Prefer age derived from birthdate; otherwise use stored age (legacy rows). */
export function getClientDisplayAge(client) {
  if (!client) return null;
  const fromBirthdate = calculateAgeFromBirthdate(client.birthdate);
  if (fromBirthdate !== null) return fromBirthdate;
  const stored = client.age;
  if (stored === null || stored === undefined || stored === '') return null;
  const n = typeof stored === 'number' ? stored : parseInt(String(stored), 10);
  return Number.isNaN(n) ? null : n;
}
